<template>
  <f7-app :params="f7params">
    <div class="loading">
      <span>Loading</span>
    </div>
    <f7-statusbar></f7-statusbar>
    <f7-view
      :main="true"
      :url="viewUrl"
      data-name="home"
      :master-detail-breakpoint="700"
    >
      <div class="bgChat view-master-detail page-master-detail">
        <img src="./assets/BGChatTT.png" />
      </div>
    </f7-view>
  </f7-app>
</template>
<style scoped>
@import "./assets/css/framework7.bundle.css";
@import "./assets/css/f7app.css";
</style>

<script>
import routes from "./f7routes.js";

export default {
  name: "App",
  data() {
    return {
      f7params: {
        routes,
        name: "CRM-Chat",
        id: "app",
      },
      viewUrl: "/chat",
    };
  },
  methods: {
    apptest() {
      console.log('.....f7app apptest....');
    },
  },
  mounted() {
    // console.log('.....f7app mounted....');
    this.$parent.closeLoading();
    // console.log("f7app", this);
    // console.log("chat page mounted");

    // if (window.location) {
    //   if (location.pathname.indexOf("employee/tim-chat") > -1) {
    //     console.log("tim employee");
    //     self.viewUrl = "/employee/tim-chat";
    //   }
    // }

    $(".loadingsvg, #lsloaddiv").hide();
    // $("#viewContent").show();

    $(function () {
      var el = $('div[data-name="home"].view.view-main')[0];
      $(el).addClass("view-master-detail");
      if ($(window).width() <= 700) {
        $(el).removeClass("view-master-detail");
      }
    });
    // is mobile device
    $(window).resize(function () {
      var el = $('div[data-name="home"].view.view-main')[0];
      if ($(window).width() <= 700) {
        $(el).removeClass("view-master-detail");
      }
    });
  },
};
</script>

